/**
 * Get the computed display value of an element.
 * This helps determine what the proper display value should be when showing the element.
 */
export const getComputedDisplay = (element: HTMLElement): string => {
  const computedStyle = window.getComputedStyle(element);
  return computedStyle.display;
};
